import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Col, Row } from 'antd';

import { guestyApi, hostawayApi, lodgifyApi } from '../../../api/partners';
import { partnersData } from '../partnersData';
import OnboardingPanel from '../../OnboardingPanel';
import OnboardingVideos from '../../OnboardingPanel/OnboardingVideos';
import OverviewLayout from '../../OverviewLayout/OverviewLayout';
import GuestyConnect from '../PartnerConnect/GuestyConnect';
import HostawayConnect from '../PartnerConnect/HostawayConnect';
import LodgifyConnect from '../PartnerConnect/LodgifyConnect';
import { Button } from '../../../ui-kit';

import { reverse } from 'utils/urls';
import { URLS } from 'components/Routes/urls';
import { IntegrationType } from 'api/types/partners';

import './PartnerLanding.scss';
import { useSignedUser } from 'api/auth';

const PartnerLanding = () => {
  const { company } = useParams();
  const { data: user } = useSignedUser();
  const data = partnersData[company];
  const history = useHistory();

  // For Guesty Integration Only
  const { data: guestyOauthData, isLoading: isGuestyOauthLoading, _ } = guestyApi.useGuestyOauth();
  const [isGuestyConnectOpen, setGuestyConnectOpen] = useState(false);
  // ============================

  // For Hostaway Integration Only
  const { data: hostawayOauthData, isLoading: isHostawayOauthLoading } =
    hostawayApi.useHostawayOauth();
  const [isHostawayConnectOpen, setHostawayConnectOpen] = useState(false);
  // ============================

  // For Lodgify Integration Only
  const { data: lodgifyOauthData, isLoading: isLodgifyOauthLoading } = lodgifyApi.useLodgifyOauth();
  const [isLodgifyConnectOpen, setLodgifyConnectOpen] = useState(false);
  // ============================

  return (
    <>
      <OverviewLayout>
        <Helmet>
          <title>{`Partnered with ${data.name} | The Host Co`}</title>
        </Helmet>

        <div className="PartnerLanding">
          <OnboardingPanel
            ownerId={user?.owner_id}
            title="Get Started"
            isComplete={false}
            isClosed={false}
            inPartners
          >
            <OnboardingVideos
              className="inPartners"
              links={data.videos}
              text={{ title: data.title, copy: data.copy }}
            />
            <div className="OnboardingPanel_checklistContainer inPartners">
              <div>
                <div className="OnboardingPanel_title">{data.heading}</div>
              </div>
              <Col className="Checklist inPartners">
                {data.instructions.map((item, idx) => (
                  <Row key={idx} wrap={false} className="Checklist_item">
                    {item}
                  </Row>
                ))}
                <Row className="button-row">
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      if (
                        (data.name === 'Guesty' || data.name === 'Guesty Lite') &&
                        !isGuestyOauthLoading
                      ) {
                        if (guestyOauthData?.exist === true) {
                          history.push(data.onContinue());
                        } else {
                          setGuestyConnectOpen(true);
                        }
                      } else if (data.name === 'Hostaway' && !isHostawayOauthLoading) {
                        if (hostawayOauthData?.exist === true) {
                          history.push(data.onContinue());
                        } else {
                          setHostawayConnectOpen(true);
                        }
                      } else if (data.name === 'Lodgify' && !isLodgifyOauthLoading) {
                        if (lodgifyOauthData?.exist === true) {
                          history.push(data.onContinue());
                        } else {
                          setLodgifyConnectOpen(true);
                        }
                      } else {
                        data.onContinue();
                      }
                    }}
                  >
                    Continue
                  </Button>
                </Row>
              </Col>
            </div>
          </OnboardingPanel>
        </div>
      </OverviewLayout>
      {/* GUESTY OAUTH CONNECT MODAL */}
      <GuestyConnect
        visible={isGuestyConnectOpen}
        onSubmit={() => {
          setGuestyConnectOpen(false);
          history.push(
            reverse({
              url: URLS.INTEGRATION,
              params: { company: IntegrationType.GUESTY.toLowerCase() },
            }),
          );
        }}
        onClose={() => {
          setGuestyConnectOpen(false);
        }}
      />
      {/* HOSTAWAY OAUTH CONNECT MODAL */}
      <HostawayConnect
        visible={isHostawayConnectOpen}
        onSubmit={() => {
          setHostawayConnectOpen(false);
          history.push(
            reverse({
              url: URLS.INTEGRATION,
              params: { company: IntegrationType.HOSTAWAY.toLowerCase() },
            }),
          );
        }}
        onClose={() => {
          setHostawayConnectOpen(false);
        }}
      />
      {/* LODGIFY OAUTH CONNECT MODAL */}
      <LodgifyConnect
        visible={isLodgifyConnectOpen}
        onSubmit={() => {
          setLodgifyConnectOpen(false);
          history.push(
            reverse({
              url: URLS.INTEGRATION,
              params: { company: IntegrationType.LODGIFY.toLowerCase() },
            }),
          );
        }}
        onClose={() => {
          setLodgifyConnectOpen(false);
        }}
      />
    </>
  );
};

export default PartnerLanding;
